<mat-tab-group #tabGroup>

  <mat-tab label="{{ 'tabOrderbook' | translate }}" bodyClass="mat-tab-hidden-overflow">
    <app-orderbook></app-orderbook>
  </mat-tab>

  <mat-tab *ngIf="isSuperUser" label="{{ 'tabAllOrders' | translate }}" bodyClass="mat-tab-hidden-overflow">
    <app-super-user-orderbook></app-super-user-orderbook>
  </mat-tab>

  <!--  <mat-tab label="{{ 'Charts' | translate }}">-->
  <!--<app-charts></app-charts>-->
  <!--  </mat-tab>-->

  <!--  <mat-tab label="{{ 'News' | translate }}">-->
  <!--<app-news></app-news>-->
  <!--  </mat-tab>-->

</mat-tab-group>

<div class="form-group d-flex justify-content-between align-items-center" *ngIf="isSuperUser && this.tabGroup.selectedIndex === 1 && (allOrders && allOrders.length > 0)">
  <button id="cancelAllOrdersBtn" class="btn btn-sm btn-primary" (click)="cancelAllOrdersInSystem()">
    <i class="fa fa-times" aria-hidden="true"></i> {{ 'buttonCancelAllOrders' | translate }}
  </button>
</div>
